import React from 'react';
import { useParams } from 'react-router-dom';
import Form from '../../components/Form/Form';
import BillOfMaterials from './Components/BillOfMaterials';

const BillOfMaterialsView: React.FC = () => {
    let id = useParams().id;

    return (
        <div className='main-content'>
            <Form>
                <Form.Header title={'Bill-of-Materials'}>
                </Form.Header>
                <Form.Content>
                    <div style={{ margin: -5, marginBottom: -15 }}>
                        {id && <BillOfMaterials id={parseInt(id)} />}
                    </div>
                </Form.Content>
            </Form>
        </div>
    );
}
export default BillOfMaterialsView;